import ROLES from "./Roles";

// Map routes to required roles
const PATH_ROLE = {
  "/sctk": ROLES.SCTK,
  "/multi-deployment": ROLES.MULTI_DEPLOYMENT,
  "/gitflow-release-management": ROLES.RELEASE_MANAGEMENT,
  "/gitflow-hotfix-management": ROLES.RELEASE_MANAGEMENT,
  "/tbd-release-management": ROLES.RELEASE_MANAGEMENT,
  "/tbd-hotfix-management": ROLES.RELEASE_MANAGEMENT,
  "/priority-groups": ROLES.RELEASE_MANAGEMENT,
  "/opened-release-hotfixes": ROLES.RELEASE_MANAGEMENT,
  "/state": ROLES.RELEASE_MANAGEMENT,
  "/aws-secrets-manager": ROLES.AWS_SECRETS_MANAGER,
  "/aws-parameter-store-manager": ROLES.AWS_PARAMETER_STORE_MANAGER,
  "/aws-cache-manager": ROLES.AWS_CACHE_MANAGER,
  "/iac-tfstate-unlock": ROLES.IAC_TFSTATE_UNLOCK,
  "/util": ROLES.UTILS,
  "/util/git": ROLES.UTILS,
  "/util/crypto": ROLES.UTILS,
  "/util/keys": ROLES.UTILS,
  "/util/git/pr-management": ROLES.UTILS,
  "/role-management": ROLES.ROLE_MANAGEMENT,
  "/user-management": ROLES.USER_MANAGEMENT,
  "/user-management/edit-user": ROLES.USER_MANAGEMENT,
  "/user-management/attach-tenants": ROLES.USER_MANAGEMENT,
  "/tenant-management": ROLES.TENANT_MANAGEMENT,
  "/ai-mode": ROLES.AI_MODE,
  "/ai-mode/ai-augmented-sdlc": [ROLES.AI_MODE, ROLES.AI_MODE_SDLC],
  "/ai-mode/ai-chat-agent": [ROLES.AI_MODE, ROLES.AI_CHAT_AGENT],
  "/ai-mode/ai-settings": [ROLES.AI_MODE, ROLES.AI_SETTINGS],
};

export default PATH_ROLE;